export default __webpack_public_path__ + "static/media/hero.c72faa58.jpg";